// extracted by mini-css-extract-plugin
module.exports = {"container":"credit_container__vnMS8","item":"credit_item__1Xlyo","type":"credit_type__2RWeL","name":"credit_name__2eqh8"};